import React from 'react';
import { Balloon } from '@alifd/next';
import IcbuIcon from '@alife/bc-icbu-icon/index';
import './index.scss';

export default function Stars(props) {
  const { stars, i18n, companyId } = props;
  const url = `https://i.alibaba.com/redirect.htm?domain=starLP&comp_id=${companyId}`;

  if (!stars) return null;

  return (
    <Balloon
      trigger={
        <span className="star-level-container">
          {stars === 0 ? (
            <span>
              <IcbuIcon
                className="star-level"
                type="grey-new-diamond"
                size="small"
              />
            </span>
          ) : (
            new Array(stars)
              .fill(' ')
              .map((_, index) => (
                <IcbuIcon
                  key={index}
                  className="star-level"
                  type="new-diamond"
                  size="small"
                />
              ))
          )}
        </span>
      }
      closable={false}
      align="bl"
      cache
      style={{ width: '274px' }}
    >
      <div className="star-level-tip">
        <div className="star-level-tip-title">
          {i18n['companyCardIntegrated.starLevel.title']}
        </div>
        <div className="star-level-tip-text">
          {i18n['companyCardIntegrated.starLevel.text']}
          <a href={url} target="_blank" rel="noreferrer">
            {' '}
            {i18n['companyCardIntegrated.starLevel.more']}
          </a>
        </div>
      </div>
    </Balloon>
  );
}
